import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5 25V7C5 5.89543 5.89543 5 7 5H25C26.1046 5 27 5.89543 27 7V25C27 26.1046 26.1046 27 25 27H7C5.89543 27 5 26.1046 5 25Z"
            fill="#B1D5F6"
            stroke="#3867A5"
            strokeLinecap="round"
            strokeWidth="2"
        />
        <path
            d="M16 3H10C9.44772 3 9 3.44772 9 4V16.2C9 16.5296 9.37631 16.7178 9.64 16.52L12.76 14.18C12.9022 14.0733 13.0978 14.0733 13.24 14.18L16.36 16.52C16.6237 16.7178 17 16.5296 17 16.2V4C17 3.44772 16.5523 3 16 3Z"
            fill="#F2DE87"
            stroke="#BB9631"
            strokeLinecap="round"
            strokeWidth="2"
        />
    </svg>
);

export default Icon;
